import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;
const VSTSACCESS = "/Vsts/";
const GETVSTSACCESS = API_URL + VSTSACCESS + "GetVstsAccess";
export const vstsAccessService = {
    getVstsAccess
}
async function getVstsAccess() {
    var url = GETVSTSACCESS;
    return axios.get(url);
}